import { lazyImport } from "../../utility/lazyImport";

const { Match } = lazyImport(() => import("../../features/match"), "Match");

const MatchRoutes = [
  {
    path: "/match/:id",
    element: <Match />,
    meta: {
      menuHidden: true,
      layout: "blank",
    },
  },
];

export default MatchRoutes;
